var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var installColorConfig = function (config) {
    return Object.keys(config).forEach(function (key) {
        document.body.style.setProperty("--".concat(key), config[key]);
    });
};
export var defaultColors = {
    "primary-blue": "#009BD5",
    "secondary-blue": "#01AAE4",
    "tertiary-blue": "#01AAE4",
    "blue-4": "rgba(0, 179, 241, 0.1)",
    "blue-5": "rgb(36, 96, 130)",
    "blue-5-transparent": "rgba(36, 96, 130, 0.1)",
    "blue-9": "rgb(49, 190, 199)",
    "blue-10": "rgba(228, 246, 253, 0.25)",
    "blue-11": "#122741",
    "blue-12": "#00132B",
    "blue-13": "#F0FAFF",
    "blue-14": "#10253F",
    "blue-15": "#9FDBEF",
    "blue-16": "#0276B1",
    "blue-17": "rgba(1, 78, 116, 1)",
    "blue-18": "rgba(42, 108, 133, 1)",
    "blue-19": "rgba(0, 112, 168, 1)",
    "lifestyle-collection-bg-blue": "rgba(42, 61, 84, 1)",
    "lifestyle-collection-bg-light-blue": "rgba(237, 246, 249, 1)",
    "lifestyle-collection-border-light-blue": "rgba(207, 225, 232, 1)",
    "lifestyle-collection-background-light-blue": "#D6E8EA",
    "user-icon-purple": "rgb(98, 54, 255)",
    "user-name-purple": "rgba(98, 54, 255, 0.2)",
    "anchor-link-blue": "#00b4ff",
    white: "#ffffff",
    "primary-text-grey": "#505050",
    "secondary-text-grey": "#878787",
    "tertiary-text-grey": "#929292",
    "grey-4": "#979797",
    "grey-5": "#d1d5db",
    "grey-6": "#aaaaaa",
    "grey-7": "#5a5a5a",
    "grey-8": "#f1f1f1",
    "grey-9": "rgb(80,80,80)",
    "grey-10": "#f6f6f6",
    "grey-11": "rgb(224, 224, 224)",
    "grey-11-transparent": "rgba(224, 224, 224, 0.1)",
    "grey-12": "rgb(80,80,80)",
    "grey-13": "#f8f7fa",
    "grey-14": "#636363",
    "grey-15": "#878787",
    "grey-16": "rgba(245, 245, 245, 1)",
    "grey-17": "rgba(192, 192, 192, 1)",
    "grey-18": "rgba(147, 150, 143, 1)",
    "green-3": "rgb(99, 182, 127)",
    "green-4": "rgb(224, 240, 229)",
    "emphasis-blue": "rgb(0, 195, 203)",
    "oat-warm-gray": "rgb(247, 243, 235)",
    "beacon-cool-gray": "#F8F8F9",
    "inactive-grey": "#f6f6f6",
    "inactive-button-icon-grey": "#d9d9d9",
    "action-button-inactive-background": "#f4f4f4",
    "action-button-inactive-text": "#878787",
    "action-button-inactive-border": "#d4d4d4",
    "action-button-active-background": "#246082",
    "action-button-active-text": "#ffffff",
    "action-link-active-text": "#246082",
    "popup-card-header-border": "rgba(0, 0, 0, 0.12)",
    "badge-green-background": "rgb(240, 245, 243)",
    "badge-blue-background": "rgba(23, 107, 109, 0.05)",
    "viator-blue": "rgba(23, 107, 109, 1)",
    "badge-red-background": "rgba(156, 33, 36, 0.07)",
    "red-text": "rgba(156, 33, 36)",
    "green-7": "rgba(14, 96, 24, 1)",
    "info-details-popup-background": "rgb(251, 251, 251)",
    "info-details-popup-border": "rgb(216, 216, 216)",
    "calendar-green": "#6fc28b",
    "calendar-yellow": "#f0a02a",
    "calendar-orange": "#e36624",
    "calendar-red": "#c20a21",
    "slider-bar-highlighted": "#008140",
    "slider-bar-inactive": "#e0e0e0",
    "text-green": "#63b67f",
    "text-green-2": "rgb(0, 129, 64)",
    "text-green-3": "#006E37",
    "red-1": "#fa6866",
    "red-2": "#e02020",
    "red-3": "#cf212b",
    "red-4": "rgba(171, 51, 43, 1)",
    "yellow-1": "#d99422",
    "yellow-2": "#f7b500",
    "yellow-3": "#e69100",
    "green-1": "#38b97a",
    "green-5": "#008140",
    "green-6": "rgba(14, 96, 24, 1)",
    "travel-credit-balance-card-background": "rgba(1, 78, 116, 1)",
    "notification-banner-positive-background": "rgba(0, 129, 64, 0.1)",
    "notification-banner-info-background": "rgba(228, 246, 253, 0.25)",
    "notification-banner-info-text": "rgb(49, 190, 199)",
    "notification-banner-info-icon-border": "rgb(49, 190, 199)",
    // CALENDAR COLORS
    "bucket-0-color": "#008140",
    "bucket-1-color": "#f0a02a",
    "bucket-2-color": "#e36624",
    "bucket-3-color": "#cc2427",
    "white-font-color": "#ffffff",
    "grey-font-color": "#505050",
    "date-hover-color": "#0076c1",
    "date-hover-text-color": "#ffffff",
    "date-selected-color": "#0076c1",
    "date-range-limit-color": "#0076c1",
    "date-disabled-color": "#d8d8d8",
    "price-freeze-text": "#31BEC7",
    "toggle-grey": "#EBEBEB",
    "white-transparent-border": "rgba(146, 79, 79, 0.25)",
    "success-light": "#59A545",
    "grey-tooltip": "rgba(255, 255, 255, 0.6)",
    "black-1": "#141414",
    "color-text-and-icon-neutral-secondary": "#6E6E6E",
    "button-primary-background": "#009BD5",
    "button-primary-hover-background": "#01AAE4",
    "button-secondary-border": "rgb(49, 190, 199)",
    "button-secondary-text": "rgb(49, 190, 199)",
    "button-secondary-hover-background": "#01AAE4",
    "recently-searched-card-cta-text": "rgb(49, 190, 199)",
    "button-secondary-hover-text": "#ffffff",
    "new-tag-background": "#01AAE4",
    "button-red-hover-background": "rgba(204, 36, 39, 1.0)",
    "footer-section-background": "rgba(1, 61, 91, 1.0)",
    "peach-pink": "#F5F1ED",
    "primary-dark-blue": "#00132B",
    "banner-root-rewards-ha-mode-background": "#f7ec88",
};
export var defaultB2BColors = __assign(__assign({}, defaultColors), { "primary-blue": "rgba(2, 118, 177, 1.0)", "secondary-blue": "rgba(2, 118, 177, 1.0)", "tertiary-blue": "rgba(2, 101, 151, 1.0)", "blue-9": "rgba(1, 61, 91, 1.0)", "blue-10": "rgba(0, 192, 229, .1)", "blue-14-transparent": "rgba(16, 37, 63, 0.9)", white: "rgba(255, 255, 255, 1.0)", "white-banner-text": "rgba(255, 255, 255, 0.75)", "white-transparent": "rgba(255, 255, 255, 0.48)", "box-shadow": "rgba(0, 0, 0, 0.05)", "backdrop-shadow": "rgba(0, 0, 0, 0.25)", "primary-text-grey": "rgba(20, 20, 20, 1.0)", "secondary-text-grey": "rgba(103, 104, 104, 1.0)", "tertiary-text-grey": "rgba(206, 207, 205, 1.0)", "grey-5": "rgba(206, 207, 205, 1.0)", "grey-6": "rgba(103, 104, 104, 1.0)", "grey-7": "rgba(103, 104, 104, 1.0)", "grey-8": "rgba(206, 207, 205, 1.0)", "grey-9": "rgba(103, 104, 104, 1.0)", "grey-10": "rgba(206, 207, 205, 1.0)", "grey-11": "rgba(206, 207, 205, 1.0)", "grey-11-transparent": "#FBFBFB", "grey-12": "rgba(103, 104, 104, 1.0)", "grey-13": "rgba(103, 104, 104, 1.0)", "grey-14": "rgba(103, 104, 104, 1.0)", "inactive-grey": "rgba(246, 246, 246, 1.0)", "inactive-button-icon-grey": "rgba(206, 207, 205, 1.0)", "action-button-inactive-background": "rgba(244, 244, 244, 1.0)", "action-button-inactive-text": "rgba(103, 104, 104, 1.0)", "action-button-inactive-border": "rgba(206, 207, 205, 1.0)", "action-button-active-background": "rgba(36, 96, 130, 1.0)", "action-button-active-text": "rgba(255, 255, 255, 1.0)", "action-link-active-text": "rgba(36, 96, 130, 1.0)", "info-details-popup-background": "rgba(251, 251, 251, 1.0)", "info-details-popup-border": "rgba(216, 216, 216, 1.0)", "calendar-green": "rgba(111, 194, 139, 1.0)", "calendar-yellow": "rgba(240, 160, 42, 1.0)", "calendar-orange": "rgba(227, 102, 36, 1.0)", "calendar-red": "rgba(194, 10, 33, 1.0)", "slider-bar-highlighted": "rgba(0, 129, 64, 1.0)", "slider-bar-inactive": "rgba(244, 244, 244, 1.0)", "badge-green-background": "rgba(240, 245, 243, 1.0)", "badge-blue-background": "rgba(23, 107, 109, 0.05)", "viator-blue": "rgba(23, 107, 109, 1)", "badge-red-background": "rgba(156, 33, 36, 0.07)", "red-text": "rgba(156, 33, 36)", "green-7": "rgba(14, 96, 24, 1)", "text-green": "rgba(99, 182, 127, 1.0)", "text-green-2": "rgba(0, 129, 64, 1.0)", "red-1": "rgba(250, 104, 102, 1.0)", "red-2": "rgba(224, 32, 32, 1.0)", "red-3": "", "red-4": "rgba(171, 51, 43, 1)", "yellow-1": "rgba(217, 148, 34, 1.0)", "yellow-2": "rgba(247, 181, 0, 1.0)", "yellow-3": "rgba(230, 145, 0, 1.0)", "green-1": "rgba(56, 185, 122, 1.0)", "light-spinner-blue": "rgba(58, 188, 253, 1.0)", "dark-spinner-blue": "rgba(2, 118, 177, 1.0)", "ftux-background-blue": "rgba(18, 39, 65, 1)", "ftux-background-blue-transparent": "rgba(18, 39, 65, 0.95)", "takeover-background-blue": "rgba(225, 245, 255, 1)", "price-freeze-text": "", "button-primary-background": "rgba(2, 101, 151, 1.0)", "button-primary-hover-background": "rgba(2, 118, 177, 1.0)", "button-secondary-text": "rgba(1, 61, 91, 1.0)", "button-secondary-border": "rgba(1, 61, 91, 1.0)", "button-secondary-hover-background": "rgba(2, 101, 151, 1.0)", "button-critical-background": "rgba(204, 36, 39, 1.0)", "button-critical-hover-background": "rgba(204, 36, 39, 1.0)", "recently-searched-card-cta-text": "rgba(1, 61, 91, 1.0)", "floating-button-background": defaultColors["blue-16"], "floating-button-border": "#3f96c1", "floating-button-divider": "#3f96c1", "floating-button-badge-background": "rgba(1, 61, 91, 1.0)", "fare-card-tag-background": "rgba(0, 192, 229, .1)", "travel-credit-balance-card-background": "#014e74", "button-book-background": "#008140", "icon-positive-background": "#008140", "banner-root-background": "rgba(1, 61, 91, 1.0)", "banner-root-text": "white", "text-inverse": "white", "loading-modal-text": "rgba(255, 255, 255, 0.75)", "loading-modal-text-strong": "rgba(255, 255, 255, 1.0)", "loading-modal-heading-text": "rgb(251, 251, 251)", "earn-tag-background": "rgba(0, 192, 229, .1)", "earn-tag-text": "rgba(1, 61, 91, 1.0)", "expiration-tag-background": "rgba(0, 192, 229, .1)", "expiration-tag-text": "rgba(1, 61, 91, 1.0)", "notification-banner-info-background": "rgba(0, 192, 229, .1)", "notification-banner-info-text": "rgba(1, 61, 91, 1.0)", "notification-banner-info-icon-border": "rgba(1, 61, 91, 1.0)", "fare-details-header-background": "rgba(1, 61, 91, 1.0)", "new-tag-background": "rgba(2, 101, 151, 1.0)", "funnel-entry-tab-selected-background": "#00132B", "hotel-refundable-tag-background": "rgba(0, 163, 207, 0.1)", "recently-viewed-tag-background": "#255f82", "card-carousel-background": "#F0F5F3", "input-field-background": "#FFFFFF", "icon-negative-background": "#CC2427", "banner-primary-light-background": "rgba(225, 245, 255, 1)", "banner-primary-light-text": "rgba(1, 61, 91, 1.0)", "banner-positive-background": "rgba(0, 129, 64, 0.1)", "banner-positive-text": "rgba(14, 96, 24, 1)", "radio-button-primary-checked": "#013D5B", "badge-primary-positive-background": "rgba(14, 96, 24, 1)", "text-critical": defaultColors["red-2"], 
    // CALENDAR COLORS
    "bucket-0-color": "rgba(0, 129, 64, 1.0)", "bucket-1-color": "rgba(214, 129, 0, 1)", "bucket-2-color": "rgba(227, 102, 36, 1.0)", "bucket-3-color": "rgba(204, 36, 39, 1.0)", "white-font-color": "rgba(255, 255, 255, 1.0)", "grey-font-color": "rgba(20, 20, 20, 1.0)", "date-hover-color": "rgba(0, 118, 193, 1.0)", "date-hover-text-color": "rgba(255, 255, 255, 1.0)", "date-selected-color": "rgba(2, 101, 151, .1)", "date-range-limit-color": "rgba(0, 118, 193, 1.0)", "date-disabled-color": "rgba(244, 244, 244, 1.0)", 
    // ALGOMERCH COLORS
    "algomerch-airline": "rgba(204, 36, 39, 1.0)", "algomerch-fareclass": "rgba(0, 118, 193, 1.0)", "algomerch-price": "rgba(0, 129, 64, 1.0)", "algomerch-duration": "rgba(240, 160, 42, 1.0)", "algomerch-stops": "rgba(1, 61, 91, 1.0)", "algomerch-duration-text": "rgba(255, 255, 255, 1.0)", 
    // PRICE PREDICTION COLORS
    "price-prediction-wait": "rgba(199, 1, 22, 1.0)", "price-prediction-fair": "rgba(89, 158, 42, 1)", "price-prediction-good": "rgba(43, 143, 54, 1)", "price-prediction-great": "rgba(13, 134, 61, 1)", 
    // PRICE PREDICTION GRADIENT COLORS
    "price-prediction-gradient-red": "rgba(199, 1, 22, 1.0)", "price-prediction-gradient-orange": "rgba(236, 130, 65, 1.0)", "price-prediction-gradient-yellow": "rgba(249, 209, 0, 1.0)", "price-prediction-gradient-green": "rgba(0, 129, 64, 1.0)", "price-prediction-gradient-green-transparent": "rgba(0, 129, 64, 0.05)", "tag-background-grey": "rgba(216, 216, 216, 0.2)", 
    // SCHEDULE CHANGE COLORS
    "red-error-color": "rgba(204, 36, 39, 1.0)", "red-error-color-transparent": "rgba(252, 213, 209, 1.0)", "warning-error-color": "rgba(249, 198, 6, 1.0)", "warning-error-color-transparent": "rgba(255, 241, 208, 1.0)", "warning-error-color-light": "rgba(249, 198, 6, 0.12)", "loading-modal-background": "#10253F", "fare-card-background": "rgba(251, 251, 251, 1.0)", "luxury-branding-blue": "#255F82", "peach-pink": "#F5F1ED" });
export var xmodColors = {
    // main brand colors
    "midnight-950": "#00132B",
    "atlantic-750": "#013D5B",
    "atlantic-750-transparent-25": "#013D5B40",
    "brick-500": "#BF5547",
    linen: "#EBE6DD",
    oat: "#F7F3EB",
    // general colors
    "blue-50": "#EBF4F5",
    "blue-100": "#D9EBED",
    "blue-550": "#306E88",
    "blue-600": "#216280",
    "blue-800": "#05314D",
    "blue-850": "#032740",
    "green-50": "#EDF5DF",
    "green-100": "#E2EDCC",
    "green-150": "#D1E0B1",
    "green-500": "#62800B",
    "green-550": "#527315",
    "green-600": "#466B11",
    "green-650": "#3E5917",
    "yellow-100": "#F7EC88",
    "yellow-200": "#EBCE2D",
    "yellow-550": "#7A6710",
    "red-100": "#FFE1DB",
    "red-300": "#E99185",
    "red-500": "#BF5547",
    "red-550": "#AD4739",
    "red-600": "#A33F31",
    "red-650": "#8F3629",
    "cool-grey-25": "#F8F8F9",
    "cool-grey-50": "#F2F3F4",
    "cool-grey-100": "#E2E4E6",
    "warm-grey-650": "#54514D",
    "warm-grey-950": "#14110D",
};
export var xmodColorVars = {
    "xmod-banner-tag-background": xmodColors["blue-50"],
    "xmod-banner-tag-text": xmodColors["atlantic-750"],
    "xmod-banner-divider": xmodColors["atlantic-750-transparent-25"],
    "xmod-calendar-selected-date-background-border": xmodColors["atlantic-750"],
    "xmod-calendar-selected-date-text": "white",
    "xmod-calendar-date-text": xmodColors["midnight-950"],
    "xmod-calendar-unselected-date-background": "white",
    "xmod-calendar-unselected-date-border": xmodColors["cool-grey-100"],
    "xmod-premier-collection-background": xmodColors["midnight-950"],
    "xmod-lifestyle-collection-background": xmodColors["blue-50"],
    "xmod-premier-search-text": defaultColors["black-1"],
    "fare-details-header-background": xmodColors["midnight-950"],
    "banner-root-background": xmodColors["blue-50"],
    "banner-root-background-premier-collection": xmodColors["midnight-950"],
    "banner-root-divider": xmodColors["atlantic-750-transparent-25"],
    "banner-root-text": xmodColors["atlantic-750"],
    "new-tag-background": xmodColors["atlantic-750"],
    "banner-primary-background": xmodColors["midnight-950"],
    "button-primary-background": xmodColors["atlantic-750"],
    "button-primary-hover-background": xmodColors["blue-850"],
    "button-secondary-border": xmodColors["atlantic-750"],
    "button-secondary-text": xmodColors["atlantic-750"],
    "recently-searched-card-cta-text": xmodColors["blue-550"],
    "button-secondary-hover-background": xmodColors["blue-850"],
    "button-secondary-hover-text": "white",
    "button-book-background": xmodColors["green-550"],
    "button-critical-background": xmodColors["red-500"],
    "button-critical-hover-background": xmodColors["red-600"],
    "text-green-2": xmodColors["green-550"],
    "green-1": xmodColors["green-550"],
    "green-5": xmodColors["green-550"],
    "xmod-free-cancellation-color": xmodColors["green-550"],
    "bucket-0-color": xmodColors["green-150"],
    "bucket-1-color": xmodColors["linen"],
    "bucket-2-color": xmodColors["red-300"],
    "bucket-0-text-color": "#141414",
    "bucket-1-text-color": "#141414",
    "bucket-2-text-color": "#141414",
    "bucket-0-price-text-color": xmodColors["green-650"],
    "bucket-1-price-text-color": xmodColors["warm-grey-650"],
    "bucket-2-price-text-color": xmodColors["red-650"],
    "date-disabled-color": xmodColors["cool-grey-25"],
    "date-selected-price-text-color": xmodColors["warm-grey-950"],
    "primary-blue": xmodColors["atlantic-750"],
    "badge-green-background": xmodColors["green-100"],
    "takeover-background-blue": xmodColors["blue-50"],
    "red-error-color": xmodColors["red-550"],
    "red-error-color-transparent": xmodColors["red-100"],
    "red-2": xmodColors["red-600"],
    "algomerch-airline": xmodColors["brick-500"],
    "algomerch-fareclass": xmodColors["atlantic-750"],
    "algomerch-price": xmodColors["green-600"],
    "algomerch-duration": xmodColors["yellow-200"],
    "algomerch-stops": xmodColors["midnight-950"],
    "algomerch-duration-text": defaultB2BColors["primary-text-grey"],
    "floating-button-background": xmodColors["atlantic-750"],
    "floating-button-border": xmodColors["atlantic-750"],
    "floating-button-divider": "rgba(255, 255, 255, 0.25)",
    "floating-button-badge-background": xmodColors["brick-500"],
    "fare-card-tag-background": xmodColors["blue-50"],
    "earn-tag-background": xmodColors["blue-50"],
    "earn-tag-text": xmodColors["atlantic-750"],
    "expiration-tag-background": xmodColors["blue-50"],
    "expiration-tag-text": xmodColors["atlantic-750"],
    "travel-credit-balance-card-background": xmodColors["atlantic-750"],
    "icon-positive-background": xmodColors["green-550"],
    "icon-negative-background": xmodColors["red-550"],
    "hotel-info-banner-background": xmodColors["green-550"],
    "loading-modal-background": "#ffffff",
    "loading-modal-text": xmodColors["warm-grey-950"],
    "loading-modal-text-strong": xmodColors["warm-grey-950"],
    "loading-modal-heading-text": xmodColors["warm-grey-950"],
    "notification-banner-positive-background": xmodColors["green-100"],
    "notification-banner-info-background": xmodColors["blue-100"],
    "notification-banner-info-text": xmodColors["warm-grey-950"],
    "notification-banner-info-icon-border": xmodColors["blue-550"],
    "funnel-entry-tab-selected-background": xmodColors["atlantic-750"],
    "light-spinner-blue": xmodColors["atlantic-750"],
    "dark-spinner-blue": xmodColors["atlantic-750"],
    "hotel-refundable-tag-background": xmodColors["blue-50"],
    "recently-viewed-tag-background": xmodColors["atlantic-750"],
    "card-carousel-background": xmodColors["oat"],
    "input-field-background": "#FFFFFF",
    "action-button-active-background": xmodColors["atlantic-750"],
    "action-link-active-text": xmodColors["atlantic-750"],
    "button-red-hover-background": xmodColors["red-600"],
    "price-prediction-gradient-red": xmodColors["red-500"],
    "price-prediction-gradient-orange": "#EC8241",
    "price-prediction-gradient-yellow": "#F9D100",
    "price-prediction-gradient-green": xmodColors["green-600"],
    "banner-primary-light-background": xmodColors["blue-100"],
    "banner-primary-light-text": xmodColors["blue-600"],
    "banner-positive-background": xmodColors["green-100"],
    "banner-positive-text": xmodColors["green-550"],
    "red-3": xmodColors["red-550"],
    "warning-error-color-transparent": xmodColors["yellow-100"],
    "warning-error-color": xmodColors["yellow-550"],
    "radio-button-primary-checked": xmodColors["atlantic-750"],
    "green-6": xmodColors["green-550"],
    "green-7": xmodColors["green-550"],
    "badge-primary-positive-background": xmodColors["green-500"],
    "text-critical": xmodColors["red-550"],
    "footer-section-background": xmodColors["midnight-950"],
};
var designSystemTheme = {
    "core_critical-bg-emphasis-high": xmodColors["brick-500"],
    "core_neutral-text-inverted": "#FFFFFF",
};
export var defaultWithXmodColors = __assign(__assign(__assign({}, defaultB2BColors), xmodColorVars), designSystemTheme);
//# sourceMappingURL=color-config.js.map